export enum SocialInfoType {
  LINKEDIN = 'linkedin',
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  STACK_OVERFLOW = 'stackoverflow',
  GITHUB = 'github',
}

export class SocialInfo {
  static setType(socialInfo: SocialInfo): SocialInfo {
    if (!!socialInfo.url) {
      socialInfo.type = null;

      Object.keys(SocialInfoType).forEach((socialInfoTypeKey: string) => {
        const socialType = SocialInfoType[socialInfoTypeKey];
        if (socialInfo?.url?.includes(socialType)) {
          socialInfo.type = socialType as SocialInfoType;
        }
      });

      if (!socialInfo.type) {
        socialInfo.type = 'website' as SocialInfoType;
      }
    }
    return socialInfo;
  }
  type: SocialInfoType;
  url: string;
}
